<template>
    <div class="clubcard-token-status">
        <div class="cash-labels">
            <!-- Voucher Status -->
            <div class="alert cash-label"
                 :class="[token.redeemable ? 'alert-success' : 'alert-danger']">
                <h4>{{ l('SEARCH_MODAL.STATUS') }}</h4>

                <div v-if="token.redeemable">
                    <span class="indicator block indicator-success">
                        {{ token.status }}
                    </span>
                </div>
                <div v-else>
                    <span class="indicator block indicator-danger">
                        {{ token.status }}
                    </span>
                </div>

                <small v-if="token.expired === true">
                    {{ l('SEARCH_MODAL.EXPIRED_DATE') }}
                    {{ dateFilter(token.expiresAt) }}
                </small>
                <small v-else>
                    {{ l('SEARCH_MODAL.EXPIRES_DATE') }}
                    {{ dateFilter(token.expiresAt) }}
                </small>
            </div>

            <!-- Remaining Balance -->
            <div class="alert alert-info cash-label">
                <h4>{{ l('SEARCH_MODAL.VALUE') }}</h4>

                <h3>{{ currencyFilter(token.value) }}</h3>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ClubcardTokenStatus',

    props: {
        token: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {

        };
    },
};
</script>
